<template>
  <CardContent>
    <h2 class="u-textItalic u-textGrow2 Groove u-padBottom04">
      Thank you for your interest in membership with Baptist Physician Partners
    </h2>
    <p>
      As a condition of membership, Baptist Physician Partners requires member physicians to have,
      and maintain at all times, hospital privileges at a Baptist Health System hospital. In
      addition, we do not accept fellows. Please do not apply if you are a fellow.
    </p>
    <p>
      Once you submit an application, we will review it and reach out with any questions or
      concerns. If you have any additional questions please contact BPP via email at
      <a href="mailto:bpp@bmcjax.com">bpp@bmcjax.com</a>. To begin, select an option below:
    </p>
    <hr/>
    <fieldset :id="'step' + formStore.currentStep + 'Fieldset'" class="u-spaceBottom2">
      <RadioButtonGroup
        v-model="applicationType"
        name="applicationType"
        id="applicationType"
        :options="[
          { id: 'newApp', label: 'New Application', value: 'new', selected: true },
          { id: 'addToGroup', label: 'Adding to Group', value: 'add' },
        ]"
        group-label="Is this a new application or are you adding to an existing group?"
        required
      />
    </fieldset>
    <!-- You can add a submit button if needed -->
    <!-- <button type="submit">Next</button> -->
  </CardContent>
</template>

<script setup>
import { watch, computed, onMounted } from 'vue'
import { useFormStore } from '../../stores/formStore'

import RadioButtonGroup from '../fields/RadioButtonGroup.vue'
import CardContent from '../CardContent.vue'

const formStore = useFormStore()

// Emit event to notify parent of validity change
const emit = defineEmits(['validity-changed'])

// Create computed property that acts as two-way binding to the store
const applicationType = computed({
  get: () => formStore.applicationType,
  set: (val) => {
    formStore.setApplicationType(val)
  },
})

// Initialize with default value if empty
onMounted(() => {
  if (!formStore.applicationType) {
    // Set default to 'new' since that's what's checked in the template
    formStore.setApplicationType('new')
  }
})

// Watch for changes in applicationType and emit validity
watch(applicationType, (newValue) => {
  const isValid = Boolean(newValue)
  emit('validity-changed', isValid)
  console.log(`Application type changed to ${newValue}, step valid: ${isValid}`)
}, { immediate: true }) // Run immediately on mount
</script>

<style scoped>
hr {
  height: 1px;
}
</style>
